"use client"

import { Button } from "@/components/ui/button"
import { ChevronLeft, ChevronRight } from "@/lib/icons"
import { useTranslations } from "next-intl"

// Extracted from components/booru-detail-modal.tsx (pure move: same JSX, same behaviour).
interface PostNavArrowsProps {
  canNavigate: { prev: boolean; next: boolean; } | undefined
  hideUI: boolean
  isAlbum: boolean
  onNavigate: ((direction: "prev" | "next") => void) | undefined
}

export function PostNavArrows({
  canNavigate,
  hideUI,
  isAlbum,
  onNavigate,
}: PostNavArrowsProps) {
  const tt = useTranslations("booruDetailModal")
  return (
    <>
      {!hideUI && onNavigate && !isAlbum && (
                <>
                  <Button
                    variant="ghost"
                    size="icon"
                    className="absolute left-[3px] top-1/2 -translate-y-1/2 h-16 w-6 rounded-sm bg-black/50 hover:bg-black/70 text-white z-10 disabled:opacity-30 disabled:cursor-not-allowed pointer-events-auto transition-all"
                    onClick={(e) => {
                      e.stopPropagation()
                      onNavigate("prev")
                    }}
                    disabled={!onNavigate || !canNavigate?.prev}
                    title={tt("previous")}
                  >
                    <ChevronLeft className="h-6 w-6" />
                  </Button>
                  <Button
                    variant="ghost"
                    size="icon"
                    className="absolute right-[3px] top-1/2 -translate-y-1/2 h-16 w-6 rounded-sm bg-black/50 hover:bg-black/70 text-white z-10 disabled:opacity-30 disabled:cursor-not-allowed pointer-events-auto transition-all"
                    onClick={(e) => {
                      e.stopPropagation()
                      onNavigate("next")
                    }}
                    disabled={!onNavigate || !canNavigate?.next}
                    title={tt("next")}
                  >
                    <ChevronRight className="h-6 w-6" />
                  </Button>
                </>
              )}
    </>
  )
}
